export default __webpack_public_path__ + "664bf757a06c22bbd1c6d5971b4f8aa4.png";